import Typography from "@material-ui/core/Typography/index";
import React from "react";
import { makeStyles } from "@material-ui/core";

const formatterStyles = makeStyles(theme => ({
  textBody: {
    color: theme.variables.rootColor,
    fontSize: "0.8125rem"
  },
  textSecondary: {
    color: "#808080",
    fontSize: "0.75rem"
  }
}));

/**
 * Format given text and highlight query
 * @param {string} query Search query
 * @param {string} string Whole text
 * @param {bool} custom Custom design
 */
function AutocompleteFormatter({
  query,
  string,
  custom,
  boldClassName,
  ...otherProps
}) {
  string = string.trim();
  query = query.trim();

  const classes = formatterStyles();
  const index = string.toLowerCase().indexOf(query.toLowerCase());
  let nextSpaceIndex = string.indexOf(" ", index + query.length);
  nextSpaceIndex === -1 && (nextSpaceIndex = index + query.length);

  const preStr = string.slice(0, index);
  const match = string.slice(index, index + query.length);
  const remainingWord = string.slice(index + query.length, nextSpaceIndex);
  const postStr = string.slice(nextSpaceIndex);

  return index > -1 ? (
    <Typography {...otherProps}>
      <span className={custom ? "" : classes.textSecondary}>{preStr}</span>
      <span className={custom ? "" : classes.textBody}>
        <b className={boldClassName}>{match}</b>
        {remainingWord}
      </span>
      <span className={custom ? "" : classes.textSecondary}>{postStr}</span>
    </Typography>
  ) : (
    <Typography className={custom ? "" : classes.textBody} {...otherProps}>
      {string}
    </Typography>
  );
}

export default AutocompleteFormatter;
